import type { VisitorConsentStatus } from "../../Booking-Form/typings/booking.types";

export type VisitorConsentLinkResendTarget =
  | { kind: "place"; placeBookingId: number }
  | { kind: "registration"; visitorRegistrationId: number };

export type VisitorConsentLinkUiState =
  | { kind: "empty" }
  | { kind: "complete"; consentCompletedAt?: string }
  | { kind: "unavailable" }
  | { kind: "sent"; action: "resend"; consentLinkSentAt?: string }
  | { kind: "send"; action: "send" };

export type VisitorConsentLinkRowContext = {
  consentStatus?: VisitorConsentStatus;
  linkSentManually: boolean;
  consentLinkSentAt?: string;
  consentCompletedAt?: string;
  placeBookingId: number;
  visitorRegistrationId?: number;
};

export function resolveVisitorConsentLinkResendTarget(
  row: Pick<VisitorConsentLinkRowContext, "placeBookingId" | "visitorRegistrationId">
): VisitorConsentLinkResendTarget | null {
  if (row.visitorRegistrationId != null) {
    return { kind: "registration", visitorRegistrationId: row.visitorRegistrationId };
  }
  if (row.placeBookingId > 0) {
    return { kind: "place", placeBookingId: row.placeBookingId };
  }
  return null;
}

export function getVisitorConsentLinkUiState(
  context: VisitorConsentLinkRowContext
): VisitorConsentLinkUiState {
  const { consentStatus, linkSentManually, consentLinkSentAt, consentCompletedAt } = context;

  if (!consentStatus) {
    return { kind: "unavailable" };
  }

  if (consentStatus === "not_required") {
    return { kind: "empty" };
  }

  if (consentStatus === "complete") {
    return {
      kind: "complete",
      consentCompletedAt: consentCompletedAt?.trim()
    };
  }

  if (!resolveVisitorConsentLinkResendTarget(context)) {
    return { kind: "unavailable" };
  }

  if (linkSentManually || consentLinkSentAt?.trim()) {
    return {
      kind: "sent",
      action: "resend",
      consentLinkSentAt: consentLinkSentAt?.trim()
    };
  }

  return { kind: "send", action: "send" };
}

export function visitorConsentLinkRowKey(context: VisitorConsentLinkRowContext): string {
  if (context.visitorRegistrationId != null) {
    return `registration-${context.visitorRegistrationId}`;
  }
  return `place-${context.placeBookingId}`;
}
